import React, {useEffect, useState, useContext} from 'react'
import DivLayout from 'components/sales/divLayout/divLayout';
import Layout from 'components/sales/layout/layout';
import localization from "../../../../assets/localization/localization";
import {BaseUrl} from "contexts/baseUrl/baseUrl";

const ViewDismantleMrf = ({
                              getDismantleMrfBySiteId,
                              dismantleMrfViewResponse=[],
                              match
                          }) => {

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getDismantleMrfBySiteId(match?.params?.site_id)
            setIsLoading(false);
        })()
    }, [])

    return (
        <Layout
            title={localization.BacktoList}
            isGoback
            isLoading={isLoading}
        >
                <div className="panel-card card-details" width="100%">

                    <div className="panel-heading">{localization.materialDetails}</div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            <DivLayout
                                heading={"MRF Id"}
                                data={
                                    dismantleMrfViewResponse?.id
                                }
                            />

                            {dismantleMrfViewResponse?.site?.lead?.id &&
                                <DivLayout
                                    heading={localization.leadID}
                                    data={
                                        dismantleMrfViewResponse?.site?.lead?.id
                                    }
                                />
                            }

                            {dismantleMrfViewResponse?.site?.site_no &&
                                <DivLayout
                                    heading={localization.siteNumber}
                                    data={
                                        dismantleMrfViewResponse?.site?.site_no
                                    }
                                />
                            }

                            <DivLayout
                                heading={localization.siteId}
                                data={
                                    match?.params?.site_id
                                }
                            />

                            {dismantleMrfViewResponse?.site?.lead?.client_name &&
                                <DivLayout
                                    heading={localization.client}
                                    data={
                                        dismantleMrfViewResponse?.site?.lead?.client_name
                                    }
                                />
                            }

                            {dismantleMrfViewResponse?.created_person?.name &&
                                <DivLayout
                                    heading={localization.raisedBy}
                                    data={
                                        dismantleMrfViewResponse?.created_person?.name
                                    }
                                />
                            }


                        </div>
                    </div>
                </div>

            {dismantleMrfViewResponse?.installation_line_items &&
                <>
                    <div className="panel-card card-details">
                        <div className="panel-heading">Installment  Line  Items</div>
                        <div className="panel-body">
                            <div className="details-listing detail_alignment">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        {/*<th>Title</th>*/}
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Material Code</th>
                                        <th>Quantity</th>
                                        <th>Sale Value</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {dismantleMrfViewResponse?.installation_line_items.map((val) => {
                                        return (
                                            <>
                                                <tr>
                                                    {/*<td>{val?.sale_value > 0 ? "Material" : " Associate Material"}</td>*/}
                                                    <th>{val?.material?.material_name}</th>
                                                    <th>{val?.material?.description}</th>
                                                    <th>{val?.material?.material_code}</th>
                                                    <th>{val?.quantity}</th>
                                                    <th>{val?.sale_value ?? 0}</th>

                                                </tr>
                                            </>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            }

                {dismantleMrfViewResponse?.additional_line_items &&
                    <>
                        <div className="panel-card card-details">
                            <div className="panel-heading">Additional Line  Items</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <table className="table table-striped">
                                        <thead>
                                        <tr>
                                            {/*<th>Title</th>*/}
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Material Code</th>
                                            <th>Quantity</th>
                                            <th>Sale Value</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {dismantleMrfViewResponse?.additional_line_items.map((val) => {
                                            return (
                                                <>
                                                    <tr>
                                                        {/*<td>{val?.sale_value > 0 ? "Material" : " Associate Material"}</td>*/}
                                                        <th>{val?.material?.material_name}</th>
                                                        <th>{val?.material?.description}</th>
                                                        <th>{val?.material?.material_code}</th>
                                                        <th>{val?.quantity}</th>
                                                        <th>{val?.sale_value ?? 0}</th>

                                                    </tr>
                                                </>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                }






        </Layout>
    )
}

export default ViewDismantleMrf